
const INITIAL_STATE = { status: false }

const ControlCloseModalLink = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_CONTROL_CLOSE_MODAL_LINK_CHANGE':
            return { status: action.payload }
        default:
            return state;
    }
}

export default ControlCloseModalLink